<template>
  <table class="tw-w-full tw-text-left tw-border tw-border-gray-300">
    <thead class="tw-bg-gray-100">
      <tr>
        <th class="tw-px-4 tw-py-2 tw-border tw-border-gray-300">
          <input
            id="select-all-companies"
            type="checkbox"
            :checked="allSelected"
            @change="toggleSelectAll"
          />
        </th>
        <th class="tw-px-4 tw-py-2 tw-border tw-border-gray-300">
          Company Name
        </th>
        <th class="tw-px-4 tw-py-2 tw-border tw-border-gray-300">
          Unlocked Periods Count
        </th>
        <th class="tw-px-4 tw-py-2 tw-border tw-border-gray-300">
          Current Version
        </th>
        <th class="tw-px-4 tw-py-2 tw-border tw-border-gray-300">
          Latest Version
        </th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="company in companies" :key="company.id">
        <td class="tw-px-4 tw-py-2 tw-border tw-border-gray-300">
          <input
            class="company-select"
            type="checkbox"
            :value="company.id"
            :checked="isSelected(company.id)"
            @change="toggle(company.id, $event)"
          />
        </td>
        <td class="tw-px-4 tw-py-2 tw-border tw-border-gray-300">
          {{ company.name }}
        </td>
        <td class="tw-px-4 tw-py-2 tw-border tw-border-gray-300">
          {{ company.periodsCount || 0 }}
        </td>
        <td class="tw-px-4 tw-py-2 tw-border tw-border-gray-300">
          {{ company.currentVersion || 0 }}
        </td>
        <td class="tw-px-4 tw-py-2 tw-border tw-border-gray-300">
          {{ company.latestVersion || 0 }}
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script setup lang="ts">
import { computed, toRefs, ref, watch } from 'vue'

type Company = {
  id: number
  name: string
  periodsCount: number
  currentVersion: number
  latestVersion: number
}

const props =
  defineProps<{
    companies: Company[]
    selectedCompanyIds: number[]
  }>()

const emit =
  defineEmits<{
    (e: 'update:selectedCompanyIds', value: number[]): void
  }>()

const { companies, selectedCompanyIds } = toRefs(props)

const selected = ref<number[]>([...selectedCompanyIds.value])

watch(
  () => selectedCompanyIds.value,
  (val) => {
    selected.value = [...val]
  }
)

const allSelected = computed(() => {
  if (companies.value.length === 0) return false
  return companies.value.every((c) => selected.value.includes(c.id))
})

function isSelected(id: number): boolean {
  return selected.value.includes(id)
}

function toggle(id: number, event: Event): void {
  const checked = (event.target as HTMLInputElement).checked
  if (checked) {
    if (!selected.value.includes(id)) {
      selected.value = [...selected.value, id]
      emit('update:selectedCompanyIds', selected.value)
    }
  } else {
    selected.value = selected.value.filter((v) => v !== id)
    emit('update:selectedCompanyIds', selected.value)
  }
}

function toggleSelectAll(event: Event): void {
  const checked = (event.target as HTMLInputElement).checked
  if (checked) {
    selected.value = companies.value.map((c) => c.id)
    emit('update:selectedCompanyIds', selected.value)
  } else {
    selected.value = []
    emit('update:selectedCompanyIds', selected.value)
  }
}
</script>
